<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>品牌管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col :span="16" style="padding: 22px;">
      <el-table :data="pageinfo.data"  @row-click="cellSelect" stripe style="width: 100%">
        <el-table-column width="32" type="expand">
           <template slot-scope="scope">
             {{ scope.row.history | safe }}
           </template>
         </el-table-column>
        <el-table-column prop="brandName" label="品牌名称" width="160"></el-table-column>
        <el-table-column prop="cover" label="封面" width="220px">
          <template slot-scope="scope">
            <img :src="scope.row.cover" style="width: 120px; height: 68px; object-fit: cover;"/>
          </template>
        </el-table-column>
        <el-table-column prop="tags" label="品牌图谱" width="200"></el-table-column>s
      </el-table>
      <el-col :span="24" class="pagenav" style="margin-top: 42px;">
        <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageinfo.page"
        :page-sizes="[12]"
        :page-size="12"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageinfo.total">
      </el-pagination>
    </el-col>
    </el-col>
    <el-col :span="8">
      <div class="tb_header">
        <div class="title"><h3><i class="el-icon-menu"></i>{{ currcell.brandName }}品牌信息</h3></div>
        <el-col>
          <el-form name="currcell" :model = "currcell" ref= "currcell">
            <el-form-item label="店铺logo" prop="logo">
              <el-upload
                class="avatar-uploader"
                :data="uploadattr"
                accept="image/*"
                name="upload"
                :action="upurl"
                :headers="$verifyhead"
                :show-file-list="false"
                :on-success="handleCoverSuccess">
                <img v-if="currcell.cover" :src="currcell.cover" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-input v-model="currcell.cover" style="display: none"></el-input>
            </el-form-item>
            <el-form-item label="品牌图谱" prop="tags" :rules="{required: true, message: '请输入品牌图谱', trigger: 'blur'}">
              <el-input v-model="currcell.tags" type="text" placeholder="请输入品牌图谱" required></el-input>
            </el-form-item>
            <el-form-item label="品牌简介" prop="desc" :rules="{required: true, message: '请输入品牌简介', trigger: 'blur'}">
              <el-input v-model="currcell.desc" rows="5" type="textarea" placeholder="请输入品牌简介" required></el-input>
            </el-form-item>
            <el-form-item label="品牌故事" prop="history" :rules="{required: true, message: '请输入品牌故事', trigger: 'blur'}">
              <el-input v-model="currcell.history" rows="5" type="textarea" placeholder="请输入品牌故事" required></el-input>
            </el-form-item>
            <el-form-item style="text-align: right">
                <el-button type="primary" @click="handleBrandUpdate('currcell')">确 定</el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-col>
  </el-row>
</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 220px;
    height: 68px;
    line-height: 68px;
    text-align: center;
  }
  .avatar {
    width: 220px;
    height: 68px;
    display: block;
  }
</style>
<script>
export default {
  name: 'Brand',
  data () {
    return {
      sData: {},
      currpage: {},
      uploadattr: {method: 'base.upload'},
      pageinfo: {page: 0, total: 0, num: 15, data: []},
      currcell: {},
      upurl: this.$apiurl
    }
  },
  mounted: function () {
    this.handleCurrentChange(1)
  },
  methods: {
    handleCurrentChange: function (page) {
      var params = this.sData
      params['page'] = page
      params['num'] = 15
      params['method'] = 'shop.brandpage'
      var that = this
      this.$http.post(that.$apiurl, params).then(function (ret) {
        that.pageinfo = ret.body.data
      })
    },
    cellSelect: function (row, event, column) {
      this.currcell = row
      return false
    },
    handleBrandUpdate: function (formname) {
      var that = this
      that.$refs[formname].validate(function (valid) {
        if (valid) {
          var para = that.currcell
          para.method = 'shop.brandupdate'
          that.$http.post(that.$apiurl, para).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('品牌更新成功!')
              that.handleCurrentChange(ret.data.page)
            } else {
              that.$alert('品牌更新失败，请稍后重试！')
            }
          })
        }
      })
    },
    handleCoverSuccess: function (response, file, fileList) {
      console.log(response)
      var that = this
      this.$set(that.currcell, 'cover', response.data.url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shop/Brand.vue